module.exports = __webpack_public_path__ + "videos/technical-support.35ccade.webm";